import React from 'react'
import { Link, NavLinkProps } from 'react-router-dom'
import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core/styles'

import { IStoreProduct, IMoney, StoreProduct } from 'protos'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ButtonBase, { ButtonBaseProps } from '@material-ui/core/ButtonBase'

import Paper from 'components/Paper'
import Badge from 'components/Badge'
import Currency from 'components/Currency'
import StoreItemName from 'components/StoreItemName'

import coinIconLevel0 from './assets/coin_stack_level_0.svg'
import coinIconLevel1 from './assets/coin_stack_level_1.svg'
import coinIconLevel2 from './assets/coin_stack_level_2.svg'
import coinIconLevel3 from './assets/coin_stack_level_3.svg'
import coinIconLevel4 from './assets/coin_stack_level_4.svg'
import coinIconLevel5 from './assets/coin_stack_level_5.svg'
import coinIconLevel6 from './assets/coin_stack_level_6.svg'
import autoSubIcon from './assets/auto_sub.svg'

interface Props extends IStoreProduct {
  className?: string
}

const styles = (theme: Theme) => createStyles({
  priceContainer: {
    padding: '4px 12px',
    borderRadius: theme.borderRadius,
  },
  button: {
    width: 100,
    height: 90,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.grey[300],
    borderRadius: theme.borderRadius,
    backgroundColor: theme.palette.common.white,
  },
  iconAndTitleContainer: {
    height: '100%',
  },
  icon: {
    height: 40,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const coinIconsMap = [
  coinIconLevel0,
  coinIconLevel1,
  coinIconLevel2,
  coinIconLevel3,
  coinIconLevel4,
  coinIconLevel5,
  coinIconLevel6,
]

const StoreItem: React.SFC<InjectedProps> = ({
  type,
  price,
  level,
  classes,
  quantity,
  productId,
  className,
}) => {
  const isCoin: boolean = type !== StoreProduct.Type.AUTOSUB
  const itemPrice: IMoney = (price && price[0]) || {}
  const linkComponent = ({ innerRef, ...props }: ButtonBaseProps) => (
    <Link {...props as NavLinkProps} to={`/store/${productId}/buy`} />
  )

  return (
    <Grid
      className={className}
      alignItems="center"
      direction="column"
      spacing={1}
      container
    >
      <Grid item>
        <ButtonBase
          className={classes.button}
          component={linkComponent}
        >
          <Grid
            className={classes.iconAndTitleContainer}
            direction="column"
            alignItems="center"
            justify="center"
            container
          >
            <Grid item>
              {isCoin && (
                <img alt="" className={classes.icon} src={coinIconsMap[level || 0]} />
              )}

              {!isCoin && !!quantity && (
                <Badge badgeContent={quantity} color="primary">
                  <img alt="" className={classes.icon} src={autoSubIcon} />
                </Badge>
              )}

              {!isCoin && !quantity && (
                <img alt="" className={classes.icon} src={autoSubIcon} />
              )}
            </Grid>
            <Grid item>
              <Typography noWrap>
                <StoreItemName product={{ productId, price, type, level, quantity }} />
              </Typography>
            </Grid>
          </Grid>
        </ButtonBase>
      </Grid>
      <Grid item>
        <Paper className={classes.priceContainer} color="accent">
          <Typography color="inherit" variant="body1">
            <Currency
              value={+(itemPrice.value || 0) / 100}
              currency={itemPrice.currency}
            />
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(StoreItem)
